export default {
    type: 'blog-posts',
    aliases: {
        camel: 'blogPosts',
        singular: 'Blog post',
        plural: 'Blog posts',
        lowerSingular: 'blog post',
        lowerPlural: 'blog posts',
    },
    relations: {
        'modules': {
            pivot: {
                type: 'blog-post-modules',
                localKey: 'blogPostId',
                foreignKey: 'moduleId'
            }
        },
        'people': {
            adminLabel: "People",
            pivot: {
                type: 'person-blog-posts',
                localKey: 'blogPostId',
                foreignKey: 'personId'
            }
        },
    },
    publishable: true,
    adminSection: 'news-and-views',
    componentType: 'base',
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPublishableCollection',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerBlogPostRecord',
            loader: () => import('./AdministerBlogPostRecord')
        },
        webRecord: {
            name: 'DisplayBlogPostRecord',
            loader: () => import('./DisplayBlogPostRecord')
        },
        webCollectionItem: {
            name: 'BlogPostPoster',
            loader: () => import('./BlogPostPoster')
        }
    },
};
